module.exports = __webpack_public_path__ + "img/geod_18.74464d01.jpg";